window.GRE_PUB_KEY = '6LclRi8rAAAAAHM_M5XvaTtjZlWb2loKDoVjGE08';
function checkisSubscribedUser() {
    let subscribed = $.cookie('isSubscribedUser');

    if (subscribed == null || subscribed == 0) {
        $('#subscribe-wall').removeClass('d-none');
    } else {
        $('#subscribe-wall').addClass('d-none');
    };
    if (!$('#subscribe-wall').length || $('#subscribe-wall').hasClass('d-none')) {
        $('#articleAside').addClass('scroll');
    }
}

var aForm = document.querySelectorAll('[data-needs-validation]');

function aFormMethods(af) {
    document.querySelectorAll('.bw-radio').forEach(el => {
        el.addEventListener('click', function () { renderDropdownSelect(this) });
    })
    const hasSelect = (select) => {
        if (select.value === '') {
            select.classList.add('gray');
        } else {
            select.classList.remove('gray');
        }
    }

    const selects = af.querySelectorAll('select');

    selects.forEach(select => {
        select.addEventListener('change', () => {
            hasSelect(select);
        });
    });

    af.addEventListener('input', () => {
        saveFormLocal(af);
        renderLabelClass();
        checkSubmitReady(af);
    });
    af.addEventListener('click', () => {
        saveFormLocal(af);
        checkSubmitReady(af);
    });
    document.addEventListener('DOMContentLoaded', () => {
        drawSavedForm(af);
        checkAll();
        checkSubmitReady(af);
    });
}

if (aForm.length) aForm.forEach(af => aFormMethods(af));

function checkSubmitReady(af) {
    const errorElements = af.querySelector('.form__error');
    let blankRequired = 0;
    const closedButton = af.closest('form').querySelector('button[type=submit]');

    af.querySelectorAll('[required]').forEach(requiredField => {
        if (requiredField.type == 'checkbox' && !requiredField.checked) {
            blankRequired++;
        } else if (requiredField.type == 'radio') {
            const name = requiredField.name;
            const oneChecked = af.querySelector(`input[type="radio"][name="${name}"]:checked`);

            if (!oneChecked) {
                blankRequired++;
            }
        } else if (!requiredField.value || requiredField.value == '') {
            blankRequired++;
        }
    })

    const submitTrigger = errorElements == null && blankRequired == 0;

    submitTrigger ? closedButton.removeAttribute('disabled') : closedButton.setAttribute('disabled', 'true');
}

function saveFormLocal(af, is_outer = false) {
    if (is_outer) {
        // console.log('bef', localStorage.getItem(is_outer[0]));
        const raw = localStorage.getItem(is_outer[0]);
        const storedData = raw ? JSON.parse(raw) : {};

        storedData[is_outer[1]] = [is_outer[2]];

        localStorage.setItem(is_outer[0], JSON.stringify(storedData));
        // console.log('aft', localStorage.getItem(is_outer[0]));
        return;
    }
    var formContent = {},
        formElements = af.querySelectorAll('input,textarea,select');

    formContent = Object.keys(formElements).reduce((sum, current) => {
        var renderValue = '',
            elementLocalName = formElements[current].localName;

        if (elementLocalName == 'input') {
            switch (formElements[current].type) {
                case 'radio':
                    checkedSelector = document.querySelector(`input[name=${formElements[current].name}]:checked`);
                    if (checkedSelector) {
                        renderValue = normalizeValue(checkedSelector.value);
                    }
                    renderLabelClass(formElements[current]);
                    break;
                case 'checkbox':
                    renderValue = formElements[current].checked;
                    renderLabelClass(formElements[current]);
                    break;
                case 'email':
                    renderValue = formElements[current].value;
                    let isBlocked = filterEmailDomains(formElements[current].value);
                    if (isBlocked) {
                        inputMessage(formElements[current], 'error', formElements[current].dataset.err);
                    };
                    if (!isBlocked) {
                        inputMessage(formElements[current], 'remove');
                    };
                    break
                default:
                    renderValue = normalizeValue(formElements[current].value);
            }
        }
        if (elementLocalName == 'textarea' || elementLocalName == 'select') {
            renderValue = formElements[current].value
        }

        function normalizeValue(value) {
            return value.replace(/"/g, '').replace(/</g, '');
        }

        return { ...sum, [formElements[current].name]: [renderValue] };
    }, 0);

    // console.log(formContent);
    // console.log($(af).attr('id'));

    localStorage.setItem($(af).attr('id'), JSON.stringify(formContent));
};

function checkAll() {
    var trigger = document.querySelectorAll('[data-checkall]');

    trigger.forEach(t => {
        t.onclick = () => {
            var checkBoxes = document.querySelectorAll(t.dataset.checkall),
                checkedCount = 0;

            checkBoxes.forEach(ch => {
                if (ch.checked == true) checkedCount += 1;
            })

            if (checkedCount < checkBoxes.length) {
                checkBoxes.forEach(ch => {
                    ch.checked = true;
                    renderLabelClass(ch);
                });
            } else {
                checkBoxes.forEach(ch => {
                    ch.checked = false;
                    renderLabelClass(ch);
                });
            }
        }
    })
}

function drawAlerts() {
    var alerts = document.querySelectorAll('[data-required]'),
        uncheckedCount = 0;

    alerts.forEach(al => {
        var targets = document.querySelectorAll(al.dataset.required),
            watcher = document.querySelector(al.dataset.watcher),
            trigger = 0;

        // console.log(al, watcher);

        targets.forEach(t => {
            switch (t.type) {
                case "checkbox":
                    if (t.checked == true) trigger += 1;
                    break;
                case "text":
                    if (t.value != '') trigger += 1;
                    break;
            }
        })

        if (trigger > 0) {
            al.classList.add('d-none');
            watcher.checked = true;
            uncheckedCount += 0;
        } else {
            al.classList.remove('d-none');
            watcher.checked = false;
            al.scrollIntoView();
            uncheckedCount++;
        };
    })
    return uncheckedCount == 0 ? 'OK' : 'error';
}

function drawSavedForm(af) {
    var formElements = af.querySelectorAll('input,textarea,select'),
        storedData = JSON.parse(localStorage.getItem(af.id));

    if (storedData) {
        formElements.forEach(el => {
            var elementLocalName = el.localName;

            if (elementLocalName == 'input') {
                switch (el.type) {
                    case 'checkbox':
                        el.checked = storedData[el.name] ? storedData[el.name][0] : false;
                        renderLabelClass(el);
                        break;
                    case 'radio':
                        if (el.value == storedData[el.name]) {
                            el.click();
                        }
                        renderLabelClass(el);
                        break;
                    default:
                        // console.log(storedData[el.name]);
                        if (typeof (storedData[el.name]) === undefined || storedData[el.name] === 'undefined' || !storedData[el.name]) {
                            el.value = '';
                        } else {
                            el.value = storedData[el.name]
                        }
                };
            }
            if (elementLocalName == 'textarea' || elementLocalName == 'select') {
                el.value = storedData[el.name];
            }
        });

        var selectDropdown = document.querySelectorAll('.form-field__dropdown');
        selectDropdown.forEach(sel => {
            var realValue = sel.parentElement.querySelector('input[type=text]').value || 'other';
            sel.querySelector('img').setAttribute('src', `/images/flags/${realValue}.svg`);
            sel.querySelector('span').innerHTML = document.querySelector(`a[data-value=${realValue}`).innerText;
        })
    }
}

function renderLabelClass(el) {
    if (!el) return;
    el.parentElement.classList.toggle('form-field_selected', el.checked == true);
}

function filterEmailDomains(value) {
    const filterArray = [
        'gmail',
        'proton',
        'protonmail',
        'pm',
        'onmicrosoft',
        'yahoo',
        'myyahoo',
        'zoho',
        'aol',
        'gmx',
        'icloud',
        'me',
        'mac',
        'web',
        't-online',
        'freenet',
        '1and1',
        'libero',
        'virgilio',
        'tim',
        'mailchimp'
    ];
    const filterRegex = new RegExp('(@|\\.)(' + filterArray.join('|') + ')\\.', 'i');

    return filterRegex.test(value)
}

function inputMessage(el, type, message = null) {
    const parentGroup = el.closest('.form__group');
    const messageSmall = parentGroup.querySelector('small');

    switch (type) {
        case 'error':
            parentGroup.classList.add('form__error');
            if (messageSmall) messageSmall.remove();
            let err =
                parentGroup.insertAdjacentHTML("beforeend", `
            <small class="error">${message}</small>`
                );
            break;
        default:
            parentGroup.classList.remove('form__error');
            if (messageSmall) messageSmall.remove();
    }
}

function greCaptcha() {
    return new Promise(resolve => {
        grecaptcha.ready(function () {
            grecaptcha.execute(window.GRE_PUB_KEY, { action: 'submit' }).then(function (token) {
                resolve(token);
            });
        })
    })
}

function sendForm(form) {
    const formId = form.attr('id');
    const requestURI = form.attr('action');

    const listSubscribersFrom = ['subscribe-sb-article'];
    const submitBtn = form.find('[type=submit]');
    const dataForm = form.attr('data-form');
    const isNotFormsSubscribeForm = listSubscribersFrom.every(item => item !== dataForm);

    const svg = `<svg class="submit-loader" xmlns="http://www.w3.org/2000/svg" width="31" height="32" viewBox="0 0 31 32" fill="none">
        <g clip-path="url(#clip0_19021_4308)">
            <path d="M2.50169 16.2272C2.37639 9.04862 8.09422 3.12763 15.2728 3.00233C22.4514 2.87703 28.3724 8.59486 28.4977 15.7735C28.623 22.9521 22.9052 28.8731 15.7266 28.9984" stroke="white" stroke-width="4"/>
        </g>
        <defs>
            <clipPath id="clip0_19021_4308">
                <rect width="30" height="30" fill="white" transform="translate(30.7593 30.7363) rotate(179)"/>
            </clipPath>
        </defs>
    </svg>`;

    const btnContent = submitBtn.find('[data-text-btn]');

    btnContent.css('opacity', '0');
    $(submitBtn).addClass('disabled-color');
    $(submitBtn).append(svg);

    $.getScript("https://www.google.com/recaptcha/api.js?render=" + window.GRE_PUB_KEY, async function () {
        let gre_token = await greCaptcha().finally(() => {
            $(submitBtn).find('svg').remove();
            btnContent.css('opacity', '1');
            $(submitBtn).removeClass('disabled-color');
        });

        let requestQuery = form.serialize() + `&gretoken=${gre_token}`;

        

        // showing corresponding modal from data id
        $('.modal').modal('hide');
        if (dataForm != 'nomodal') {
            $.post(requestURI, requestQuery, data => $(`#${data}`).modal('show'));
        } else {
            // run function with same name
            $.post(requestURI, requestQuery, data => {
                console.log(typeof window[data]);
                window[data.trim()]()
            });
        }
    })
}

$(document).on('submit', "form", function (e) {
    e.preventDefault();
    let checkAlerts = drawAlerts();

    if (checkAlerts == 'OK') sendForm($(this));
})

$(document).ready(function () {
    setDefaultSelect("form#hubspot-footer-form");
    $('#isnt_subscibe').on('shown.bs.collapse	', function () {
        setDefaultSelect("form#hubspot-sub-form");
    })
})

function setDefaultSelect(inputForm) {
    // country is always gb on the UK site
    const iso = 'gb';
    const targetForm = $(inputForm);
    // console.log(targetForm);

    if ($(targetForm).length) {
        if ($(inputForm + ' input[name="COUNTRY"]').length) {
            // console.log($('input[name="COUNTRY"]'));
            const targetCountry = `input[name="COUNTRY"][value='${iso}']`;
            $(targetForm).find(targetCountry).closest('.bw-radio').click();
        } else {
            $('#COUNTRY').val(iso);
        }
    }

    // investor is always private: INVESTOR_TYPE 1
    if ($(targetForm).length) {
        if ($(inputForm + ' input[name="INVESTOR_TYPE"]').length) {
            $(targetForm).find(`input[name="INVESTOR_TYPE"][value='1']`).closest('.bw-radio').click();
        } else {
            $('#INVESTOR_TYPE').val(1);
        }
    }
}

function renderDropdownSelect(el) {
    let parentSel = el.closest('.bw-dropdown').querySelector('.bw-select');
    let valHTML = el.querySelector('[data-input-value]').innerHTML;
    parentSel.innerHTML = valHTML;
}

function dropdownCheckboxes(target) {
    console.log(target);
}